import { AsyncPipe, NgClass } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ClientSubscriptionFreezeStatus } from '@fitness-force/enum';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'freeze-status',
  templateUrl: './freeze-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, NgClass, TranslateModule],
})
export class FreezeStatusComponent {
  private readonly cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;

  getFreezeStatus(value: any) {
    // Check if value is already a number
    if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
      return ClientSubscriptionFreezeStatus[value];
    }

    // Check if value can be parsed as a valid integer
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue) && isFinite(parsedValue)) {
      return ClientSubscriptionFreezeStatus[parsedValue];
    }

    // If value is not a number, return it as is (might be a string enum key)
    return value;
  }

  renderClass(status: string | number): string {
    const statusKey =
      typeof status === 'number'
        ? ClientSubscriptionFreezeStatus[status]
        : status;
    switch (statusKey) {
      case ClientSubscriptionFreezeStatus[
        ClientSubscriptionFreezeStatus.ScheduledFreeze
      ]:
        return 'bg-blue-500';
      case ClientSubscriptionFreezeStatus[
        ClientSubscriptionFreezeStatus.FreezeInprogress
      ]:
        return 'bg-blue-500';
      case ClientSubscriptionFreezeStatus[
        ClientSubscriptionFreezeStatus.FreezeCompleted
      ]:
        return 'bg-green-500';
      case ClientSubscriptionFreezeStatus[
        ClientSubscriptionFreezeStatus.FreezeCancelled
      ]:
        return 'bg-gray-500';
      case ClientSubscriptionFreezeStatus[
        ClientSubscriptionFreezeStatus.FreezeStopped
      ]:
        return 'bg-orange-500';
      default:
        return 'bg-gray-500';
    }
  }
}
